interface SelectProps<Option extends string> {
    label: string;
    options: readonly Option[];
    value: Option;
    className?: string;
    ariaLabel?: string;
    id?: string;
    defaultValue?: Option;
    onChange: (option: Option) => void;
    optionLabel?: (option: Option) => string | undefined;
}

export const SimpleSelect = <Option extends string>({
    label,
    options,
    value,
    className,
    ariaLabel,
    id = 'simple-select',
    defaultValue,
    onChange,
    optionLabel,
}: SelectProps<Option>) => {
    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedOption = options.find(option => option === event.target.value);
        if (selectedOption === undefined) {
            throw new Error(`Ukjent valg: ${event.target.value}`);
        }
        onChange(selectedOption);
    };

    return (
        <div className="select-container">
            <label className="o-select-text" htmlFor={id}>
                {label}
            </label>
            <select
                id={id}
                className={`o-select-select ${className || ''}`}
                onChange={handleChange}
                value={value}
                aria-label={ariaLabel ?? label}
                defaultValue={defaultValue}
            >
                {options.map(option => (
                    <option key={option} value={option}>
                        {optionLabel ? optionLabel(option) : option}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default SimpleSelect;
